import React, { FC } from 'react';

const Payments: FC = () => {
  return <h3>Payments</h3>;
};

export default Payments;
